import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InventoryWorksheetPageRoutingModule } from './inventory-worksheet-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { InventoryItemModalComponent } from './components/inventory-item-modal/inventory-item-modal.component';
import { InventoryCountCardComponent } from './components/inventory-count-card/inventory-count-card.component';
import { InventoryEditCardComponent } from './components/inventory-edit-card/inventory-edit-card.component';
import { InventoryGroupSortProductDataComponent } from './components/inventory-group-sort-product-data/inventory-group-sort-product-data.component';
import { InventoryWorksheetPage } from './inventory-worksheet.page';
import { SharedModule } from '@shared/shared.module';
import { TooltipCatchweightComponent } from './components/tooltip-catchweight/tooltip-catchweight.component';
import { InventoryActionModalDesktopTabletComponent } from './components/inventory-action-modal/inventory-action-modal-desktop-tablet/inventory-action-modal-desktop-tablet.component';
import { InventoryActionModalMobileComponent } from './components/inventory-action-modal/inventory-action-modal-mobile/inventory-action-modal-mobile.component';
import { ProductDetailPageModule } from '../../../product-detail/product-detail.module';
import { InventoryDeleteModalComponent } from './components/inventory-delete-modal/inventory-delete-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InventoryInformationModalComponent } from './components/inventory-information-modal/inventory-information-modal.component';
import { InventoryCustomUomModalComponent } from './components/inventory-custom-uom-modal/inventory-custom-uom-modal.component';
import { InventoryWorksheetSkeletonComponent } from './components/inventory-worksheet-skeleton/inventory-worksheet-skeleton.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    InventoryWorksheetPageRoutingModule,
    SharedModule,
    ProductDetailPageModule,
    DragDropModule,
  ],
  declarations: [
    InventoryWorksheetPage,
    InventoryItemModalComponent,
    InventoryGroupSortProductDataComponent,
    InventoryCountCardComponent,
    InventoryEditCardComponent,
    TooltipCatchweightComponent,
    InventoryActionModalDesktopTabletComponent,
    InventoryActionModalMobileComponent,
    InventoryDeleteModalComponent,
    InventoryInformationModalComponent,
    InventoryCustomUomModalComponent,
    InventoryWorksheetSkeletonComponent,
  ],
  providers: [DatePipe],
})
export class InventoryWorksheetModule {}
